export default (state: any, action: any) => ({
  ...state,
  leadsPool: {
    ...state.leadsPool,
    isSaving: action.isSaving,
  },
});
